import { useFormikContext } from "formik";
import { CSSProperties, useRef } from "react";
import ReactSelect, { ClearIndicatorProps } from "react-select";



const CustomClearText = () => <i>azzera</i>;

const ClearIndicator = (props: ClearIndicatorProps<any, true>) => {

  const { setFieldValue } = useFormikContext();

  const {
    children = <CustomClearText />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  const clearValue = async (e) => {
    e.preventDefault();
    setFieldValue(props.selectProps.name, '');
    props.clearValue();
  }

  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles('clearIndicator', props) as CSSProperties}
    >
      <div style={{ padding: '0px 5px' }} onClick={ (e) => clearValue(e) }>{children}</div>
    </div>
  );
};

const ClearIndicatorStyles = (
  base,
  state: ClearIndicatorProps<any>
) => ({
  ...base,
  cursor: 'pointer',
  color: state.isFocused ? 'blue' : 'black',
});


export default function Select({ 
  disabled = false, 
  name = "", 
  classNames = {}, 
  placeholder, 
  value, 
  onChange, 
  isTransparent = false, 
  options = [],
  isClearable = false 
}) {

  const selectRef = useRef();

  const defaultStyles = {
      indicatorSeparator: styles => ({ ...styles, backgroundColor: 'none' }),
      container: styles => {
        return {
          ...styles
        };
      },
      control: styles => {
        return {
          ...styles,
          backgroundColor: 'transparent',
          borderColor: isTransparent ? 'transparent' : 'hsl(0, 0%, 80%)'
        }
      },
      singleValue: styles => ({ ...styles, color: '#000' }),
      menu: styles => ({ ...styles, position: 'static', backgroundColor: 'transparent' }),
      // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      //   return {
      //     ...styles,
      //     backgroundColor: 'transparent',
      //     color: '#fff',
      //     ':active': {
      //       backgroundColor: 'green'
      //     }
      //   }
      // }
  };

  const handleChange = (newValue, actionMeta) => {
    onChange(newValue || '');
  }

  return (
      <ReactSelect
        ref={selectRef}
        components={{ ClearIndicator }}
        classNames={{
          ...classNames,
          singleValue: (state) => `!text-neutral-500 text-black dark:!text-neutral-400`,
          option: (state) => ``,
          input: (state) => `!text-neutral-500 dark:!text-neutral-400 dark:text-black`,
          
        }}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        isSearchable
        isDisabled={disabled}
        isClearable={isClearable}
        styles={defaultStyles}
        options={options}
        value={value}
        defaultValue={""}
      />
  );
}